<style scoped lang="less">
.num {
	display: flex;
	flex-direction: column;
	justify-content: flex-start;
	width: 60%;
}

.nump {
	// width: 6vw !important;
	font-size: 1.4vw !important;
}

.statoisicetitle {
	height: 12rem;
	margin-bottom: 1rem;

	/deep/ .el-row {
		height: 100%;

		.el-col {
			height: 100%;

			.statoisicel {
				height: 100%;
			}
		}
	}
}

.statoisicel {
	position: relative;
	z-index: 1;
	overflow: hidden;

	.statoisiceq {
		width: 100%;
		position: absolute;
		display: flex;
		align-items: flex-start;
		justify-content: flex-start;
		top: 6%;
		left: 0%;
		z-index: 9999;
		color: #fff;

		.statoisiceql {
			width: 74%;

			p {
				margin-bottom: 0.3rem;
				font-size: 0.8rem;
			}

			p:first-child {
				margin-bottom: 1rem;
				font-size: 1.5vw;
				font-weight: 700;
			}
		}

		img {
			width: 5rem;
			height: 5rem;
			margin: 0 1rem;
			border-radius: 50%;
		}
	}
}

.statoisicer {
	padding: 1rem 0.4rem;
	box-sizing: border-box;
	overflow: hidden;
	border: 1px solid;
	border-radius: 10px;
	height: 97%;
	background-color: #0898ff;
	color: #fff;

	.statoisiceb {
		margin-top: 1rem;
		padding-top: 0.6rem;
		border-top: 1px solid;

		ul {
			display: flex;
			align-items: center;
			justify-content: space-between;

			li {
				display: flex;
				align-items: center;
				padding: 0.4rem 0;
				width: 25%;
				justify-content: space-around;

				.num {
					p {
						// margin-top: 10px;
						font-size: 12px;
						transform: scale(0.9);
						margin-right: 0.4rem;
						width: 8vw;
					}

					/deep/ .number-grow {
						font-size: 2vw;
						color: #fff;
					}
				}

				span {
					font-weight: 900;
					font-size: 2.5vw;
					padding: 0.4rem;
					// margin-right: 10px;
					background-color: #fff;
					border: 1px solid transparent;
					border-radius: 5px;
				}
			}
		}
	}

	.statoisicet {
		ul {
			display: flex;
			align-items: center;
			justify-content: space-between;

			li {
				display: flex;
				align-items: center;

				p {
					width: 7rem;
					text-align: right;
				}
			}

			li:last-child {
				width: 6rem;

				button {
					width: 100%;
					padding: 0.4rem 0.4rem;
					border-radius: 2px;

					span {
						color: #47cb77;
						font-weight: 700;
					}
				}
			}

			li:nth-child(2) {
				padding-left: 10px;
				margin-left: 1%;
				padding-right: 10%;

				/deep/ .el-input {
					width: 100%;

					input {
						width: 100%;
						height: 2rem;
					}

					span {
						top: 4px;
					}
				}
			}

			li:first-child {
				/deep/ .el-input__inner {
					width: 100%;
					height: 2rem;
				}

				/deep/ .el-range-input {
					width: 100%;

					// .el-range-input {
					// 	height: 2rem;
					// 	width: 60%;
					// }
				}

				/deep/ .el-range__icon {
					margin-bottom: 0.5rem;
					margin-right: 6px;
				}

				/deep/ .el-range-separator {
					margin-right: 14px;
					margin-bottom: 7px;
				}
			}
		}
	}
}

.ability {
	width: 100%;
	margin-bottom: 1rem;
	padding: 1rem;
	background: #fff;
	border-radius: 5px;

	.abilitybottom {
		width: 60%;
		margin: 1rem auto;

		p {
			display: flex;
			margin-bottom: 1rem;
		}
	}

	.datesactive {
		background-color: #dae0e5 !important;
	}

	.abilitysgn {
		span {
			margin: 0 0.4rem;
			font-size: 1rem;
			font-weight: 700;
		}
	}

	.abilitytitle {
		display: flex;
		align-items: center;
		justify-content: space-between;
		margin-bottom: 1rem;

		p {
			font-size: 0.8rem;
			color: #333;
			font-weight: 800;
		}

		.datas {
			border-radius: 5px;

			span {
				padding: 0.8rem;
				background: #f0f0f0;
			}
		}

		button {
			padding: 0.2rem;
			background: #f0f0f0;
			border-radius: 2px;
			letter-spacing: 1px;

			span {
				margin-left: 0.2rem;
			}
		}
	}
}

/deep/ #sxpice {
	min-height: 40vh;
}
</style>
<template>
	<div>
		<titles titlename="班级数据分析" titlecontent="这里可以看到班级数据分析" :mbx="paths"></titles>
		<div class="statoisicetitle">
			<el-row :gutter="20">
				<el-col :xs="24" :sm="24" :md="24" :lg="8" :xl="8">
					<div class="statoisicel">
						<img style="width: 100%;height: 100%;position: relative;z-index: 1111;" src="../../images/classdhed.svg" alt="" />
						<div class="statoisiceq">
							<img v-if="bjobjclass.si_pictureUrl" :src="bjobjclass.si_pictureUrl" alt="" />
							<img v-else src="../../images/header.png" alt="" />
							<div class="statoisiceql">
								<p>{{ bjobjclass.cla_name }}</p>
								<p>
									学员总数：
									<span>{{ bjobjclass.cla_count }}</span>
									人
								</p>
								<p>
									班级编号：
									<span>{{ bjobjclass.cla_nameNumber }}</span>
								</p>
								<p>
									所属专业：
									<span>{{ bjobjclass.pro_name }}</span>
								</p>
								<p>
									所属院校：
									<span>{{ bjobjclass.si_name_cn }}</span>
								</p>
							</div>
						</div>
					</div>
				</el-col>
				<el-col :xs="24" :sm="24" :md="24" :lg="16" :xl="16">
					<div class="statoisicer">
						<div class="statoisicet">
							<ul>
								<li>
									<p>数据分析统计：</p>
									<div style="width: 100%;">
										<el-date-picker
											@change="timerchanges()"
											v-model="beginendtimer"
											type="daterange"
											range-separator="至"
											start-placeholder="开始日期"
											end-placeholder="结束日期"
										></el-date-picker>
									</div>
								</li>
								<li>
									<p>实训设备：</p>
									<el-select @change="trainsbchange()" v-model="sxsb" placeholder="请选择">
										<el-option v-for="item in options" :key="item.sx_te_guid" :label="item.te_deviceName" :value="item.sx_te_guid"></el-option>
									</el-select>
								</li>
								<li>
									<button @click="getbjcanem()">
										<span class="el-icon-refresh"></span>
										刷新
									</button>
								</li>
							</ul>
						</div>

						<div class="statoisiceb">
							<ul>
								<li>
									<span class="el-icon-timer" style="color: #57CA22;"></span>
									<div class="num">
										<p class="nump">
											{{ trainobjnum.sumTrainTime }}
											<span style=" padding:0; font-size: 11px;background-color: transparent;">/小时</span>
										</p>
										<!-- <numbergrow :value=""></numbergrow> -->
										<p>累计实训时长</p>
									</div>
								</li>
								<li>
									<span class="el-icon-timer" style="background: #E6A130;"></span>
									<div class="num">
										<p class="nump">
											{{ trainobjnum.sumTrainCount }}
											<span style="padding:0; font-size: 11px;background-color: transparent;">/次</span>
										</p>
										<!-- <numbergrow :value=""></numbergrow> -->
										<p>累计实训次数</p>
									</div>
								</li>
								<li style="width: 20%;">
									<span class="el-icon-timer" style="background: #8D6AFC;"></span>
									<div class="num">
										<p class="nump">{{ trainobjnum.avgTrainScore }}</p>
										<!-- <numbergrow :value=" "></numbergrow> -->
										<p>实训平均分</p>
									</div>
								</li>
								<li style="width: 20%;">
									<span class="el-icon-timer" style="background: #57CA23;"></span>
									<div class="num">
										<p class="nump">{{ trainobjnum.maxTrainScore }}</p>
										<!-- <numbergrow :value="trainobjnum.maxTrainScore"></numbergrow> -->
										<p>实训最高分</p>
									</div>
								</li>
								<li style="width: 15%;">
									<span class="el-icon-timer" style="background: #D85450;"></span>
									<div class="num" style="margin-left: 10px;">
										<p class="nump">{{ trainobjnum.minTrainScore }}</p>
										<!-- <numbergrow :value=""></numbergrow> -->
										<p>实训最低分</p>
									</div>
								</li>
							</ul>
						</div>
					</div>
				</el-col>
			</el-row>
		</div>

		<el-row :gutter="20">
			<el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
				<div class="ability">
					<div class="abilitytitle">
						<p>综合能力评估</p>
						<!-- <button>
							<span class="el-icon-edit"></span>
							<span>自定义参数</span>
						</button> -->
					</div>
					<el-empty v-if="powernull == 0" description="暂无评估,请班级人员预约实训"></el-empty>
					<div style="width: 100%;height: auto;" v-show="powernull == 1"><axischarts :datetype="'linear'"></axischarts></div>
					<div class="abilitybottom" v-if="powernull == 1">
						<p>
							星级指数：
							<span>
								<el-rate v-model="scores" :max="10" disabled text-color="#ff9900"></el-rate>
								<!-- <strat :scores="scores"></strat> -->
							</span>
						</p>
						<p>
							智能点评：
							<i style="color: red; text-decoration: underline;">{{ dpconteng }}</i>
						</p>
					</div>
				</div>
			</el-col>
			<el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
				<div class="ability">
					<div class="abilitytitle">
						<p>实训时长分析</p>
						<p class="datas">
							<span :class="{ datesactive: datactive == 1 }" @click="datactivechange(1)">年</span>
							<span :class="{ datesactive: datactive == 2 }" @click="datactivechange(2)">月</span>
							<span :class="{ datesactive: datactive == 3 }" @click="datactivechange(3)">周</span>
						</p>
					</div>
					<el-empty
						v-if="timernull == 0"
						:description="
							datactive == 1 ? '本年暂无实训时长,请班级人员进行实训' : datactive == 2 ? '本月暂无实训时长,请班级人员进行实训' : '本周暂无实训时长,请班级人员进行实训'
						"
					></el-empty>
					<div v-show="timernull == 1"><histogramstudent :datetype="'pie'"></histogramstudent></div>
				</div>
				<div class="ability">
					<div class="abilitytitle">
						<p>
							{{ orderstimer }}月实训成绩分析
							<span></span>
						</p>
						<p class="abilitysgn">
							<span @click="GetClassInfoTacj()" style="cursor: pointer;" class="el-icon-refresh"></span>
							<el-dropdown @command="changedatas" trigger="click">
								<span class="el-icon-s-tools"></span>
								<el-dropdown-menu slot="dropdown">
									<el-dropdown-item v-for="(item, index) in datalist" :key="index" :command="item">{{ item }}</el-dropdown-item>
								</el-dropdown-menu>
							</el-dropdown>
						</p>
					</div>
					<el-empty v-if="ordersnull == 0" description="暂无成绩,请班级人员进行考试"></el-empty>
					<div v-show="ordersnull == 1"><histogramstudent :datetype="'pie1'"></histogramstudent></div>
				</div>
			</el-col>
		</el-row>
	</div>
</template>

<script>
import titles from '@/components/title/title.vue';
import numbergrow from '@/components/numberdt/numbergrow.vue';
import histogramstudent from '@/components/chats/histogramstudent.vue';
import axischarts from '@/components/chats/axischarts.vue';
import strat from '@/components/strat.vue';
import {
	GetbjClassInfo,
	GetbjClassInfoSTA, // 获取班级统计数据
	GetClassInfoSTAModelApi, //更改的班级统计数据
	GetClassInfoComprehensiveScoreSTA, //能力掌握
	ModelGetClassInfoComprehensiveScoreSTAPI, // 更改的能力掌握
	GetClassInfoTainTimeLengthSTA, // 实训时长
	ModelGetClassInfoTainTimeLengthSTAPI, // 修改实训时长
	GetClassInfoTainScoreSTA, // 实训成绩分析
	GetClassInfoTainScoreSTAPI, //修改实训成绩分析
	GetyyTrainEquipmentList
} from '@/request/api/dataorder/dataprder.js';

import AppOptions from '@/config/AppOptions.vue';

export default {
	data() {
		return {
			// 一到十二月
			datalist: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
			// 班级实训时长分析
			classtrainobj: {
				timetype: 'year',
				parms: new Date().getFullYear()
			},
			// 时长成绩分析
			orderstimer: new Date().getMonth() + 1,
			// 空状态
			powernull: 1,
			ordersnull: 1,
			timernull: 1,
			trainobjnum: {},
			// 班级数据分析
			trainclassobj: {},
			bjobjclass: {},
			// 标题
			paths: [
				{
					path: '/allmanage/statistics',
					name: '数据分析与统计'
				},
				{
					path: '/information/classstatistics',
					name: '班级数据分析'
				}
			],
			// 开启停止时间
			beginendtimer: '',
			// 选择器

			options: [],
			sxsb: '',
			datactive: 1,
			scores: 5,
			// 页面尺寸
			cheoxs: false,
			Optiondata: [],
			Optiondata2: [],
			Optiondata3: [],
			dpconteng: ''
		};
	},
	beforeMount() {
		this.trainclassobj = JSON.parse(this.$cookie.get('classbin'));

		this.getbjdata();
	},
	mounted() {
		this.chars();
	},
	created() {
		AppOptions.appEmpty = false;
	},

	methods: {
		// 点击刷新
		getbjcanem() {
			this.GetbjClassnum();
		},

		// // 更改设备列表
		trainsbchange() {
			setTimeout(async () => {
				await this.GetbjClassnum();
				await this.getClassInfoCompre();
				await this.GetClassInfoTainTim();
				await this.GetClassInfoTacj();
			}, 200);
		},

		timerchanges() {
			// console.log(this.beginendtimer)
			// console.log(new Date(this.beginendtimer[0]).toLocaleDateString())
			let begintimer = new Date(this.beginendtimer[0]).toLocaleDateString();
			let endtimer = new Date(this.beginendtimer[1]).toLocaleDateString();

			this.beginendtimer[0] = begintimer;
			this.beginendtimer[1] = endtimer;
			// console.log(this.beginendtimer)
			// this.GetbjClassnum()
		},
		//

		changedatas(command) {
			this.orderstimer = command;
			// console.log(command)
			this.GetClassInfoTacj();
		},

		datactivechange(i) {
			this.datactive = i;
			if (i == 1) {
				this.classtrainobj.timetype = 'year';
				this.classtrainobj.parms = new Date().getFullYear();
				this.GetClassInfoTainTim();
			} else if (i == 2) {
				this.classtrainobj.timetype = 'month';
				this.classtrainobj.parms = new Date().getFullYear() + '/' + parseInt(new Date().getMonth() + 1);
				this.GetClassInfoTainTim();
			} else if (i == 3) {
				this.classtrainobj.timetype = 'week';
				this.classtrainobj.parms = new Date().toLocaleDateString();
				this.GetClassInfoTainTim();
			}
		},

		getbjdata() {
			GetbjClassInfo(this.trainclassobj.cla_guid).then(res => {
				// console.log(res,"班级数据分析")
				if (res.data.data) {
					this.bjobjclass = res.data.data;
					GetyyTrainEquipmentList(this.bjobjclass.si_guid).then(res => {
						// console.log(res)
						this.options = res.data.data;
						if (this.options.length > 0) {
							this.sxsb = this.options[0].sx_te_guid;
							setTimeout(async () => {
								await this.GetbjClassnum();
								await this.getClassInfoCompre();
								await this.GetClassInfoTainTim();
								await this.GetClassInfoTacj();
							}, 200);
						}
					});
				} else {
					// this.$message({
					// 	message: '暂无数据',
					// });
				}
			});
		},
		GetbjClassnum() {
			let bjvlassobj = {
				cla_guid: this.trainclassobj.cla_guid,
				startTime: this.beginendtimer[0] ?? '',
				endTime: this.beginendtimer[1] ?? '',
				sx_te_guid: this.sxsb
			};
			// GetbjClassInfoSTA(bjvlassobj).then(res => {
			GetClassInfoSTAModelApi(bjvlassobj).then(res => {
				console.log(res, '班级统计数据');
				this.trainobjnum = res.data.data;
				this.trainobjnum.sumTrainTime = Math.round(this.trainobjnum.sumTrainTime * 100) / 100;
				this.trainobjnum.avgTrainScore = Math.round(this.trainobjnum.avgTrainScore * 100) / 100;
				this.trainobjnum.maxTrainScore = Math.round(this.trainobjnum.maxTrainScore * 100) / 100;
				this.trainobjnum.minTrainScore = Math.round(this.trainobjnum.minTrainScore * 100) / 100;

				// console.log(this.trainobjnum)
			});
		},
		// // 获取图表
		getClassInfoCompre() {
			let clasinfoobj = {
				cla_guid: this.trainclassobj.cla_guid,
				sx_te_guid: this.sxsb,
				taskName: '',
				startTime: '',
				endTime: ''
			};
			// GetClassInfoComprehensiveScoreSTA(clasinfoobj).then(res => {
			ModelGetClassInfoComprehensiveScoreSTAPI(clasinfoobj).then(res => {
				// console.log(res, "综合能力评估")
				var chart1 = this.$echarts.init(document.getElementById('sector1'));
				if (res.data.data && res.data.data.list.length > 0) {
					this.notes = res.data.data.notes;
					let nums = res.data.data.score;
					this.scores = Math.floor(nums);
					this.dpconteng = res.data.data.notes;
					var projelist = [];
					var optionlist = [];
					res.data.data.list.forEach(item => {
						let projeobj = {};
						projeobj.name = item.projectName;
						projeobj.max = 100;
						projelist.push(projeobj);
						let numsa = item.projecScore;
						optionlist.push(numsa);
					});
					let maxnum = Math.max(...optionlist) + 10;
					projelist.forEach(item => {
						item.max = maxnum;
					});

					this.$store.commit('changechatclonetitle', projelist);
					this.Optiondata = optionlist;
					this.$store.commit('changechatclone', this.Optiondata);
					this.$store.commit('changechatclonemax', maxnum);

					chart1.setOption(this.$store.state.optionclone);
				} else {
					this.powernull = 0;
					// this.$message({
					// 	message: '暂无数据'
					// });
				}
			});
		},
		GetClassInfoTainTim() {
			let clasfoobj = {
				cla_guid: this.trainclassobj.cla_guid,
				timetype: this.classtrainobj.timetype,
				parms: this.classtrainobj.parms,
				sx_te_guid: this.sxsb
			};
			// GetClassInfoTainTimeLengthSTA(clasfoobj).then(res => {
			ModelGetClassInfoTainTimeLengthSTAPI(clasfoobj).then(res => {
				// console.log(res, "实训时长")
				var chart2 = this.$echarts.init(document.getElementById('sxpice'));
				if (res.data.data && res.data.data.length > 0) {
					this.timernull = 1;
					var Trainlistdate = [];
					var Optiondata2s = [];
					res.data.data.forEach(item => {
						Optiondata2s.push(item.count);
						if (this.datactive == 1) {
							Trainlistdate.push(item.date.slice(-2) + '月');
						} else {
							Trainlistdate.push(item.date.slice(-2) + '日');
						}
					});
					this.Optiondata2 = Optiondata2s;
					this.$store.commit('changemouth', Trainlistdate);
					this.$store.commit('changechatows', this.Optiondata2);
					this.$nextTick(()=>{
						chart2.setOption(this.$store.state.option1);
						
						chart2.resize();
					})
					
				} else {
					// this.$message({
					// 	message: '暂无数据',
					// });
					this.timernull = 0;
					// console.log("暂无数据")
				}
			});
		},
		GetClassInfoTacj() {
			let ainScorobjs = {
				cla_guid: this.trainclassobj.cla_guid,
				month: this.orderstimer
			};
			// console.log(ainScorobjs)
			// GetClassInfoTainScoreSTA(ainScorobjs).then(res => {
			GetClassInfoTainScoreSTAPI(ainScorobjs).then(res => {
				// console.log(res, '实训成绩分析')
				var chart3 = this.$echarts.init(document.getElementById('sxpople'));
				if (res.data.data && res.data.data.length > 0) {
					this.ordersnull = 1;
					var trainNamelist = [];
					res.data.data.forEach(s => {
						if (trainNamelist.indexOf(s.projectName) < 0) {
							trainNamelist.push(s.projectName);
						}
					});
					var trainlist = [];
					var resultList = [];
					var rees = {};

					trainNamelist.forEach(s => {
						trainlist = res.data.data.filter(t => t.projectName == s);
						rees = {};
						var resultListorder = [];
						trainlist.forEach(is => {
							resultListorder.push(is.score);
						});
						rees.name = s;
						rees.type = 'line';
						rees.data = resultListorder;
						rees.smooth = true;
						resultList.push(rees);
					});
					this.Optiondata3 = resultList;
					this.$store.commit('changechathree', this.Optiondata3);
					this.$nextTick(() => {
						chart3.setOption(this.$store.state.option2);
						chart3.resize();
					});
				} else {
					this.ordersnull = 0;
					this.Optiondata3 = [];
					this.$nextTick(() => {
						chart3.setOption(this.$store.state.option2);
					});
					// this.$message({
					// 	message: '暂无数据'
					// });
				}
			});
		},

		chars() {
			this.$store.commit('changechatclone', this.Optiondata);
			this.$store.commit('changechatows', this.Optiondata2);
			this.$store.commit('changechathree', this.Optiondata3);
			var chart1 = this.$echarts.init(document.getElementById('sector1'));
			let optionclone = this.$store.state.optionclone;
			// chart1.setOption(this.$store.state.optionclone);
			chart1.resize();

			var chart2 = this.$echarts.init(document.getElementById('sxpice'));
			chart2.setOption(this.$store.state.option1);

			var chart3 = this.$echarts.init(document.getElementById('sxpople'));
			chart3.setOption(this.$store.state.option2);

			chart2.resize();
			chart3.resize();
			window.onresize = () => {
				return (() => {
					chart1.resize();
					chart2.resize();
					chart3.resize();
				})();
			};
		}
	},

	components: {
		titles,
		numbergrow,
		histogramstudent,
		strat,
		axischarts
	}
};
</script>
